import { ReactComponent as DiscordLogoSvg } from "../../media/DiscordLogo.svg"

export default DiscordLogoSvg